import { ToastContainer } from '@captaincause/ui/Toaster'

export function Portals() {
  return (
    <div id="portals">
      <ToastContainer />
    </div>
  )
}
